import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { LanguageStore } from '../../../shared/services/language.store';
import { ACS_WARRANTY_TABLE_LINK_EN, ACS_WARRANTY_TABLE_LINK_FR } from '../../../shared/helpers/constants';
import { ExpandButtonComponent } from '../expand-button/expand-button.component';

@Component({
  selector: 'acs-assistance-plus-option-section',
  imports: [
    FormsModule,
    MatRadioButton,
    MatRadioGroup,
    ReactiveFormsModule,
    TranslatePipe,
    ExpandButtonComponent
  ],
  templateUrl: './assistance-plus-option-section.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssistancePlusOptionSectionComponent {
  @Input() fc!: FormControl;

  #languageStore = inject(LanguageStore);
  get guaranteesTableLink() {
    return this.#languageStore.currentLanguageCode() === 'fr'
      ? ACS_WARRANTY_TABLE_LINK_FR
      : ACS_WARRANTY_TABLE_LINK_EN;
  }

  expanded: boolean = false;

  expandPanel() {
    this.expanded = !this.expanded;
  }
}
